import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const SelectWrapper = styled.div`
  width: 100%;
`;

const Dropdown = ({
  value, options, className, onChange,
}) => {
  const { t } = useTranslation();

  return (
    <SelectWrapper className={className}>
      <Select
        isSearchable={false}
        placeholder={t('components.dropdown.placeholder')}
        options={options}
        onChange={onChange}
        value={value}
      />
    </SelectWrapper>
  );
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.objectOf(PropTypes.any),
};

Dropdown.defaultProps = {
  value: null,
  className: '',
};

export default Dropdown;
